module.exports = __webpack_public_path__ + "static/media/pretty2.3dda2972.png";